export const createAnalytics = (track, { element, type }) => (detail) => track({
  event: {
    element,
    detail,
    type,
  },
});
